import { useEffect } from 'react';

import { scrollTop } from 'utils/scroll';

export const useScrollTopOnLoad = () => {
  useEffect(scrollTop, []);
};
